<template>
  <div>
    <div class="h3 mb-10">Отправка анкеты</div>

    <e-alert v-if="!isQuestionnaireSent" variant="info" class="mb-10">
      <div class="paragraph-m_h font-600">Проверьте правильность заполнения анкеты перед отправкой.</div>

      <div class="paragraph-s_h text-secondary">
        После отправки анкета будет направлена в отдел контента для модерации
      </div>
    </e-alert>

    <page-content-placeholder
      v-else
      :img-src="imgMessageOk"
      text="Анкета успешно отправлена на модерацию"
      max-width="640px"
    />

    <div v-if="!isQuestionnaireSent" class="d-flex">
      <e-btn variant="primary" prepend-icon-src="messageSend" class="ml-auto" :loading="isLoading" @click="submit"
        >Отправить анкету</e-btn
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import imgMessageOk from '@/assets/img/pages/support/ok.svg';
import PageContentPlaceholder from '@/core/components/common/PageContentPlaceholder.vue';
import { EAlert, EBtn } from '@/core/components/ui';
import { useContentStore } from '@/parts/content/store';

const { sendQuestionnaire, isQuestionnaireSent } = useContentStore();

const isLoading = ref(false);

const submit = async () => {
  isLoading.value = true;
  await sendQuestionnaire();
  isLoading.value = false;
};
</script>
